import GLOBAL from 'static/global.js'
import * as type from '../mutation-types'
import storeService from '../storeService'

const getUserStatus = () => {
  return storeService.get('userStatus').then(res => {
    if (res.code === 20000) {
      let data = res.result
      data.canBuy = {
        account: data.has_yingmi_account,
        bank: data.has_yingmi_pwd,
        pwd: data.has_yingmi_bank,
        risk: data.risk_status
      }
      GLOBAL.batch_id = data.batch_id
      GLOBAL.uid = data.uid
      GLOBAL.nid = data.nid
      return data
    } else {
      return res
    }
  })
}

const state = {
  islogin: '', // 是否已登录
  isPay: '', // 是否已支付498
  canBuy: {
    account: false, // 开户
    bank: false, // 银行卡
    pwd: false, // 密码
    risk: false // 风险评测
  },
  alreadyBuy: false // 是否已购买组合
}

const actions = {
  INIT ({commit, state}) {
    if (this.state.userinfoStore.islogin === '') {
      return getUserStatus().then(data => {
        commit(type.UPDATE_LOGIN_STATE, data.is_login)
        commit(type.UPDATE_PAY_STATE, data.pay_status)
        commit(type.TRADE_STATUS, data.trade_status)
        commit(type.CAN_BUY, data.canBuy)
        return data
      })
    }
  },
  userStatus ({commit, state}) {
    return getUserStatus().then(data => {
      commit(type.UPDATE_LOGIN_STATE, data.is_login)
      commit(type.UPDATE_PAY_STATE, data.pay_status)
      commit(type.TRADE_STATUS, data.trade_status)
      commit(type.CAN_BUY, data.canBuy)
      return data
    })
  }
}

const mutations = {
  [type.UPDATE_LOGIN_STATE] (state, type) {
    state.islogin = type
  },
  [type.UPDATE_PAY_STATE] (state, type) {
    state.isPay = type
  },
  [type.CAN_BUY] (state, type) {
    state.canBuy = type
  },
  [type.TRADE_STATUS] (state, type) {
    state.alreadyBuy = type
    // state.alreadyBuy = false
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/userinfoStore.js